<template>

  <v-container>
    <v-layout
        fluid
        wrap
        class="mx0 my0 px0 py0"
      >
        <v-flex
          fluid
          md12
          sm12
          class="mx0 my0 px0 py0"
        >

          <v-list>
            <v-toolbar color="success" flat class="mx0 my0 px0 py0">
              <v-toolbar-title class="white--text text--darken-4">Documentos Pendentes</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-progress-circular
                indeterminate
                color="white"
                v-show="loadingPendProcesso"
              ></v-progress-circular>
            </v-toolbar>
            
            <v-list-item-group v-if="pendencias && pendencias.length">
              
              <v-list-item 
                v-for="(item, index) in pendencias"
                :key="index"
                style="padding: 0; maring: 0;"
                v-show="!item.isExcluido"
                fill-width
              > <!-- v-show="!item.isExcluido" -->

                <v-list-item-content class="py-0 px-5 my-0 mx-0">
                  {{ item.descricao }}
                </v-list-item-content>

                <v-list-item-action class="py-0 px-0 my-0 mx-0" @click='selecionar(item)'>
                  <v-icon class="py-0 px-0 my-0 mx-0" color="success lighten-1" v-if="item.dt_confirmacao">mdi-check-circle</v-icon>
                  <v-icon class="py-0 px-0 my-0 mx-0" v-else color="error lighten-1">mdi-close-circle</v-icon> <!--mdi-radiobox-blank -->
                </v-list-item-action>

                <!--<v-divider
                  v-if="index + 1 < pendencias.length"
                  :key="index"
                  class="py-0 px-0 my-0 mx-0"
                ></v-divider>--> 

              </v-list-item>

            </v-list-item-group>

          </v-list>
        </v-flex>
      </v-layout>
  </v-container>
  
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'PendenciasProcesso',
  /*props: {
    pendenciasprop: {
      type: Array,
      default: () => []
    },
  },*/
  data () {
    return {
      loading: false,
      pendencias: [],
      pendenciasCompare: []
    }
  },
  created() {
    this.sincronizar(this.pendencia_processo)
  },

  watch: {
    pendencia_processo(newVal) {
      this.sincronizar(newVal)
    }
  },

  methods: {
    sincronizar (obj) {
      this.pendencias = JSON.parse(JSON.stringify(obj))
      this.pendenciasCompare = JSON.parse(JSON.stringify(obj))
    },
    selecionar(item) {
      if (item.dt_confirmacao) {
        item.dt_confirmacao = null
      } else {
        let atual = this.$moment(new Date()).format('YYYY-MM-DD');
        item.dt_confirmacao = atual
      }
    },
    gravar() {
      return this.pendencias
    },
    formFoiAlterado() {
      let formAlterado = !(_.isEqual(this.pendencias, this.pendenciasCompare))
      if (formAlterado) return true
      return false
    }
  },

  computed: {
    ...mapState('processo', [
      'pendencia_processo',
      'loadingPendProcesso'
    ]),
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Processo/PendenciaProcesso.vue